__turbopack_context__.v({
  "dragging": "TwoColumnFeatures-module__uIfFoW__dragging",
  "inside": "TwoColumnFeatures-module__uIfFoW__inside",
  "wrapper": "TwoColumnFeatures-module__uIfFoW__wrapper",
});
